import { useState, useEffect } from 'react';
import { homeownerBillingService } from '../services/api';

const useSubscriptionStatus = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [hasActiveSubscription, setHasActiveSubscription] = useState(false);
  const [subscriptionData, setSubscriptionData] = useState(null);

  const checkSubscriptionStatus = async () => {
    // console.log('useSubscriptionStatus - checkSubscriptionStatus called');
    try {
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      // console.log('useSubscriptionStatus - user from localStorage:', user);
      
      // If user is not logged in, they're considered free
      if (!user.id) {
        // console.log('useSubscriptionStatus - No user ID found, setting as free');
        setHasActiveSubscription(false);
        localStorage.setItem('hasActiveSubscription', 'false');
        setIsLoading(false);
        return;
      }

      // Check if user has active subscription
      // console.log('useSubscriptionStatus - Making API call...');
      const response = await homeownerBillingService.getSubscription();
      
      // console.log('useSubscriptionStatus - API response:', response);
      
      if (response.data.status === 'success' && response.data.data) {
        const subscription = response.data.data;
        // console.log('useSubscriptionStatus - subscription data:', subscription);
        
        // Check if subscription is active or cancelled but still in current period
        const isActive = subscription.status === 'active' && 
                        new Date(subscription.current_period_end) > new Date();
        
        const isCancelledButActive = subscription.status === 'cancelled' && 
                                   new Date(subscription.current_period_end) > new Date();
        
        
        setSubscriptionData(subscription);
        setHasActiveSubscription(isActive);
        localStorage.setItem('hasActiveSubscription', isActive.toString());
      } else {
        // No active subscription
        // console.log('useSubscriptionStatus - No subscription data found');
        // console.log('useSubscriptionStatus - Response:', response);
        setHasActiveSubscription(false);
        setSubscriptionData(null);
        localStorage.setItem('hasActiveSubscription', 'false');
      }
    } catch (error) {
      console.error('Error checking subscription status:', error);
      // Default to showing ads if we can't determine status
      setHasActiveSubscription(false);
      localStorage.setItem('hasActiveSubscription', 'false');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    checkSubscriptionStatus();
  }, []);

  // Function to manually refresh subscription status
  const refreshSubscriptionStatus = async () => {
    setIsLoading(true);
    await checkSubscriptionStatus();
  };

  return {
    isLoading,
    hasActiveSubscription,
    subscriptionData,
    refreshSubscriptionStatus,
    shouldShowAds: !hasActiveSubscription && !isLoading
  };
};

export default useSubscriptionStatus; 